<ng-container *ngIf="contextMenuService.menus.$ | async as menus">
    <bazis-context-menu
        *ngFor="let contextMenu of menus"
        [contextMenu]="contextMenu"
    ></bazis-context-menu>
</ng-container>
